export class StarterCancelRebook {
    public FromJourney: string;
    public Origin: string;
    public Destination: string;
    public DepartureDate: string;
}